module.exports = __webpack_public_path__ + "img/curvainferior.43fc9f15.svg";